import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, CardContent, Dialog, Grid, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { CountdownCmp } from "../countdown/Countdown";
import { NoticeCountdownCmp } from "../countdown/NoticeCountdown";
import { title } from "process";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import { useMutation } from "react-query";
import { CancelPaymentSettlement } from "../../services/supplierPayment.service";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router-dom";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
interface props {
  openModel: boolean;
  setSendConfirmation: any;
  setOpenVerifyModal: any;
  setReloadData: any;
  paymentKey: string;
  settlementAmount: number;
  allowRoute?: boolean;
}
export default function ModalCancelPaymentSettlement({
  openModel,
  setSendConfirmation,
  setOpenVerifyModal,
  setReloadData,
  paymentKey,
  settlementAmount,
  allowRoute,
}: props) {
  const [open, setOpen] = React.useState<boolean>(openModel);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSendConfirmation(false);
    setOpenVerifyModal(false);
  };
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);
  const history = useHistory();
  const { mutate: CancelPaymentSettlementMutate } = useMutation(
    CancelPaymentSettlement,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success(" عملیات با موفقیت انجام شد.");
          setReloadData(uuidv4());
          handleClose();
          if (allowRoute) {
            history.push("/Payment/SettlementWithReceiver");
          }
        } else {
          handleClose();
        }
      },
    }
  );
  const handleConfirm = () => {
    CancelPaymentSettlementMutate({ paymentSettlementKey: paymentKey });
  };
  function handleOnCompletedClick() {
    setSendConfirmation(true);
    setOpen(false);
    setOpenVerifyModal(false);
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <>
          <Grid>
            <Box
              sx={style}
              style={{ borderRadius: "6px", padding: "2px 40px 40px 40px" }}
              className="ModalCmp  "
            >
              <Grid
                item
                xs={12}
                className="classCenter"
                style={{ paddingTop: "5vh" }}
              >
                <span className="textFont16 colorDefaultFont">
                  آیا از
                  <span className="DangerDefaultFont"> لغو درخواست تسویه </span>
                  با مبلغ&nbsp;
                  <span className="DangerDefaultFont">
                    {settlementAmount && settlementAmount.toLocaleString("fa")}{" "}
                    ریال
                  </span>
                  &nbsp;اطمینان دارید؟
                </span>
              </Grid>

              <Grid container xs={12} style={{ paddingTop: "5vh" }}>
                <Grid item xs={6} style={{ textAlign: "end" }}>
                  <Button
                    type="submit"
                    className={"btnForm DangerDefault "}
                    style={{ width: "170px", marginLeft: "1vh", color: "#fff" }}
                    onClick={handleConfirm}
                  >
                    بله
                  </Button>
                </Grid>
                <Grid item xs={6} style={{ paddingRight: "2vh" }}>
                  <Button
                    className="btnForm ComingBack"
                    style={{
                      width: "170px",
                      marginLeft: "1vh",
                      textAlign: "left",
                      color: "#fff",
                    }}
                    onClick={handleClose}
                  >
                    خیر
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </>
      </Modal>
    </div>
  );
}
